var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import bind from 'bind-decorator';
import dayjs from 'dayjs';
import { camelizeKeys, isAndroidApp, underscoreKeys } from '@lean-body/src/util';
import { getFormattedToFormat } from '@lean-body/src/util';
import { Announcement, Announcements, Badge, Campaign, resolveSignupCampaignCode, Lesson, LessonSession, LiveLesson, MatchingAssessment, Plan, Playlist, Program, SearchResult, Trainer, UserChallenge, UserProfile, WatchedLessonRanking, UserLessonSessionGroupByDaily, Activity, Banner, Dialog, Footer, Maintenance, FriendInvitationCampaign, Style, Tag, UserSeasonAggregate, LeagueStatus, LeagueLeaderboard, BasePlan, Payment, AmazonPayPlan, UnsubscribeCautionLesson, CourseDay, DailyWorkoutTask, DailyStepsTask, DailyTasks, CoachingPlan, CoachingAmazonPayPlan, GoalMatchingAssessmentResponse, WeightGoalApproach, GoalMatchingAssessmentAnswerResponse, MealMenu, MealPreset, UserMeal, LessonSection, UserMealsForDay, MealCalorie, TargetWeightAndBodyFat, WeightAndBodyFatActivities, StepActivities, CurrentStreak, SaveUserWeightResult, LessonCompletionResult, StreakCompletionResult, StreakCompletionSummary, CountLessonCoach, CountLessons, CountLessonDetail, CountLessonCompletionResult, } from '../domain';
import { Merchandise } from '../domain/merchandise';
import { BeginnerMission, MissionList, MissionSummary } from '../domain/mission';
import { APIServerError, BadRequestError, ForbiddenError, NotFoundError, UnauthorizedError, UnderMaintenance, } from '../errors';
import { CustomWorkout } from '../domain/custom_workout';
import { UserCustomWorkout } from '../domain/user_custom_workout';
import { Nutrient } from '../domain/nutrient';
import { MealScore } from '../domain/meal_score';
import { WorkoutCalories } from '../domain/workout_calories';
import { ChatbotSection } from '../domain/chatbot_section';
import { DailyStartVolume } from '../domain/daily_start_volume';
import { DailyStart } from '../domain/daily_start';
import { DailyLesson } from '../domain/daily_lesson';
import { DailyLessonVolume } from '../domain/daily_lesson_volume';
import { DailyLessonDaysLesson } from '../domain/daily_lesson_day_lesson';
/*=============================================
= API Client =
=============================================*/
/** GET 本文が T[] 直返しか ResponseWithMeta<T[]> かを吸収する（バックエンド差分対策） */
function normalizeArrayResponse(data) {
    if (data == null)
        return [];
    if (Array.isArray(data))
        return data;
    const wrapped = data;
    return Array.isArray(wrapped.response) ? wrapped.response : [];
}
/**
 * APIクライアント
 * @class
 */
export class APIClient {
    constructor(config, localStorage, unauthorizedCallback, maintenanceCallback) {
        /**
         * 認証成功時にgetできるauthトークン
         */
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unauthorizedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maintenanceCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requestQueues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        this.localStorage = localStorage;
        this.unauthorizedCallback = unauthorizedCallback;
        this.maintenanceCallback = maintenanceCallback;
        this.config = config;
        this.axios = axios.create({
            baseURL: config.apiBaseURL,
            timeout: 20000, // 20000ms = 20sec
            withCredentials: true,
        });
        this.axios.interceptors.request.use((req) => {
            req.data = underscoreKeys(req.data);
            const headers = { 'X-Platform': isAndroidApp() ? 'android' : 'web' };
            req.headers = Object.assign(Object.assign({}, req.headers), headers);
            return req;
        });
        this.axios.interceptors.response.use((res) => {
            res.data = camelizeKeys(res.data);
            return res;
        }, (error) => {
            this.onError(error);
        });
    }
    onError(error) {
        if ('config' in error) {
            const e = error;
            if (!e.response) {
                throw e;
            }
            const data = camelizeKeys(e.response.data);
            console.log(data); // sentryでエラーの文言を表示できるように出力する
            switch (e.response.status) {
                case 401: // jwtトークン期限切れ
                    this.unauthorizedCallback();
                    throw new UnauthorizedError(e.message, data.message, e.response.status);
                case 403:
                    throw new ForbiddenError(e.message, data.message, e.response.status, data.errorCode);
                case 404:
                    throw new NotFoundError(e.message, data.message, e.response.status);
                case 400:
                    throw new BadRequestError(e.message, data.message, e.response.status);
                // サーバメンテナンス状態
                case 503: {
                    this.maintenanceCallback();
                    const maintenance = new Maintenance(data);
                    throw new UnderMaintenance(e.message, e.response.status, maintenance);
                }
                default:
                    if (data.message) {
                        throw new APIServerError(e.message, data.message);
                    }
                    else {
                        throw error;
                    }
            }
        }
        throw error;
    }
    // 別々クラスで呼ばれるAPIリクエストを先着順で実行するコントロール処理
    appendToSequence(name) {
        return __awaiter(this, void 0, void 0, function* () {
            let queue;
            if (this.requestQueues.has(name)) {
                queue = this.requestQueues.get(name);
            }
            else {
                queue = [];
                this.requestQueues.set(name, queue);
            }
            let resolve;
            const promise = new Promise((r) => {
                resolve = r;
            });
            // リクエスト終了後、次のリクエストへコントロールを渡すために呼ぶ関数
            const next = () => {
                queue.shift();
                resolve(null);
            };
            queue.push(promise);
            const idx = queue.indexOf(promise);
            yield queue[idx - 1];
            return next;
        });
    }
    createSetupIntent() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/setup_intent');
            return res.data.response;
        });
    }
    createSetupIntentByCustomer() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/setup_intent');
            return res.data.response;
        });
    }
    createUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/users', params);
            return res.data;
        });
    }
    signUp(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/signup_with_payment_method', params);
            return res.data.response;
        });
    }
    signIn(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/auth/token', params);
            return res.data;
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete('/me/auth/token');
        });
    }
    ping() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/ping');
            yield res.data.response;
        });
    }
    /**
     * FBサインイン・登録
     * @param params
     */
    fbSignIn(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/fb_signin', params);
            return res.data;
        });
    }
    /**
     * LINEサインイン・登録
     * @param params
     */
    lineSignIn(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/line_signin', params);
            return res.data;
        });
    }
    /**
     * Appleサインイン nonce取得
     */
    nonce() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/nonce');
            return res.data;
        });
    }
    /**
     * MeRepositoryだけで使用するmethod
     * meの取得はAccountService#fetchMeを利用する
     */
    _fetchMe() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me');
            return res.data;
        });
    }
    /**
     * 認可API。ユーザーがサービスを利用できるか検証する
     * AccountService#authorization を利用してください
     * サービスが利用できない例) 休眠中, 有効期限切れ, メアド登録のみでクレカ未登録
     */
    _authorization() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/authorization');
            return res.data.response;
        });
    }
    /**
     * 署名付きCookie取得
     */
    fetchSignedCookies() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.get('/me/signed_cookies').catch((err) => {
                if (err.isUnauthorizedError)
                    return; // 有効期限切れの場合、sentryへの送信しない
            });
        });
    }
    /**
     * 自分の招待コードを取得
     */
    fetchInvitationCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/invitation_code');
            return res.data;
        });
    }
    /**
     * お友だち紹介で利用できるキャンペーンコードを取得
     */
    fetchInvitationCampaignCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/invitation_campaign_code');
            return res.data;
        });
    }
    /**
     * クレカ登録
     * @param params
     */
    registerPayment(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/payment_with_payment_method', params);
            return new Payment(res.data.response, this.config);
        });
    }
    /**
     * @deprecated
     * @param params
     */
    registerOnce(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/registration_once', params);
            return res.data;
        });
    }
    /**
     * コーチングプラン取得
     * @param params
     */
    fetchCoachingPlan() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/coaching_plan');
            return new CoachingPlan(res.data.response);
        });
    }
    /**
     * AmazonPayコーチングプラン取得
     * @param params
     */
    fetchCoachingAmazonPayPlan() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/coaching_amazon_pay_plan');
            return new CoachingAmazonPayPlan(res.data.response);
        });
    }
    /**
     * 失敗した PaymentIntent 情報を取得
     */
    fetchFailedPaymentIntent() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/failed_payment_intent');
            return res.data.response;
        });
    }
    /**
     * コーチングプラン登録
     * @param params
     */
    registerCoachingPayment(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/coaching_payment', params);
            return;
        });
    }
    /**
     * コーチングプラン停止
     * @param params
     */
    deleteCoachingPayment() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete('/me/coaching_payment');
            return;
        });
    }
    /**
     * メアド変更
     * @param params
     */
    changeEmail(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/email', params);
            return;
        });
    }
    /**
     * パスワード変更
     * @param params
     */
    changePassword(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/password', params);
            return;
        });
    }
    /**
     * 支払い情報変更
     * @param params
     */
    changePaymentSource(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/payment_with_payment_method', params);
            return;
        });
    }
    /**
     * Program一覧取得
     * @param page
     * @param sortBy
     */
    fetchProgramList(page, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/programs?page=${page}&sort_by=${sortBy}`);
            const programData = res.data || [];
            return programData.map((v) => new Program(v, this.config));
        });
    }
    /**
     * プログラム単体取得
     * @param slug
     */
    fetchProgramWithSlug(slug) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/programs/${slug}`);
            return new Program(res.data, this.config);
        });
    }
    /**
     * レッスン単体を取得
     * @param slug
     */
    fetchLessonWithSlug(slug, courseLessonID) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = courseLessonID ? `?course_days_lesson_id=${courseLessonID}` : '';
            const res = yield this.axios.get(`/lessons/${slug}${queryParams}`);
            return new Lesson(res.data, this.config);
        });
    }
    /**
     * スタイル(レッスン様式)を取得
     */
    fetchStyles() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/styles`);
            return res.data.map((v) => new Style(v));
        });
    }
    /**
     * レッスンの部位を取得
     */
    fetchPartTags() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/part_tags`);
            return res.data.map((v) => new Tag(v));
        });
    }
    fetchSessionDurations() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/session_durations`);
            return normalizeArrayResponse(res.data);
        });
    }
    fetchExerciseRoutines() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/exercise_routines`);
            return normalizeArrayResponse(res.data);
        });
    }
    fetchExerciseRestrictions() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/exercise_restrictions`);
            return normalizeArrayResponse(res.data);
        });
    }
    fetchAvailableTools() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/available_tools`);
            return normalizeArrayResponse(res.data);
        });
    }
    /**
     * レッスンの時間を取得
     */
    fetchDurationsForSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/durations`);
            return res.data.response;
        });
    }
    /**
     * 動画視聴開始時に叩かれる。動画視聴のセッションを開始
     * @param params
     */
    startLessonSession(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post(`/me/lesson_sessions`, params);
            return res.data;
        });
    }
    /**
     * 動画視聴中に一定間隔で叩く。視聴アクティビティ情報を同期する。
     * @param params
     */
    syncLessonSession(params) {
        this.axios.patch('/me/lesson_sessions/sync', params);
    }
    /**
     * 動画視聴終了時に叩く。startLessonSessionと対になる
     * @param params
     */
    finishLessonSession(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/lesson_sessions/finish', params);
            return new LessonCompletionResult(res.data, this.config);
        });
    }
    /**
     * ライブレッスン視聴記録作成(Start)
     */
    startLiveLessonWatchingRecord(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post(`/me/live_lessons/${id}/watching_record`);
            const { session } = res.data.response;
            return new LessonSession(session, this.config);
        });
    }
    /**
     * ライブレッスン視聴記録更新(Complete)
     */
    finishLiveLessonWatchingRecord(id, lessonWatchingTime, deduplicatedLessonWatchingTime, userLessonSessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            // iOSアプリは画面遷移・離脱時に window.finishLiveLessonWatchingRecord を呼ぶが、
            // 直後にwebviewが破棄されるため通常のXHRだと送信が中断されPATCHがサーバに届かないことがある。
            // keepaliveを付けたfetchで送ることで、ドキュメント破棄中でもリクエストを送り切る。
            // (sendBeaconはPOST固定でPATCH不可のためfetch keepaliveを使う)
            const res = yield this.axios.patch(`/me/live_lessons/${id}/watching_record`, {
                lessonWatchingTime,
                deduplicatedLessonWatchingTime,
                userLessonSessionId,
            }, {
                adapter: 'fetch',
                fetchOptions: { keepalive: true },
            });
            const { session, userSeasonAggregate } = res.data.response;
            this.localStorage.saveUserSeasonAggregateRank(userSeasonAggregate);
            return new LessonSession(session, this.config);
        });
    }
    /**
     * ライブレッスン視聴記録更新(Sync)
     */
    syncLiveLessonWatchingRecord(id, lessonWatchingTime, deduplicatedLessonWatchingTime, userLessonSessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch(`/me/live_lessons/${id}/sync_watching_record`, {
                lessonWatchingTime,
                deduplicatedLessonWatchingTime,
                userLessonSessionId,
            });
        });
    }
    createStreakFromLiveLesson(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post(`/me/live_lessons/${id}/streak`);
            const { streakCompletionResult } = res.data.response;
            return streakCompletionResult && new StreakCompletionResult(streakCompletionResult, this.config);
        });
    }
    /**
     * レッスン動画視聴履歴取得
     */
    fetchLessonHistory() {
        return __awaiter(this, arguments, void 0, function* (page = 0) {
            const res = yield this.axios.get(`/lessons?filter=watched&page=${page}`);
            return res.data.response.map((d) => new Lesson(d, this.config));
        });
    }
    /**
     * 視聴履歴データを取得
     */
    fetchLessonSession() {
        return __awaiter(this, arguments, void 0, function* (page = 0) {
            const res = yield this.axios.get(`/me/lesson_history?page=${page}`);
            return res.data.response.map((session) => new LessonSession(session, this.config));
        });
    }
    /**
     * レッスンセクションデータを取得
     */
    fetchLessonSection() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/lesson_sections');
            return res.data.response.map((lessonSection) => new LessonSection(lessonSection, this.config));
        });
    }
    /**
     * 視聴アクティビティの集計を行なった後、メールなどの普遍的な情報以外のプロフィールを取得。(視聴回数など)
     */
    patchProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/aggregated_profile');
            return new UserProfile(res.data, this.config);
        });
    }
    /**
     * userProfile を取得.
     */
    fetchMypageProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/mypage_profile');
            return new UserProfile(res.data, this.config);
        });
    }
    /**
     * userProfile を更新.
     */
    patchMypageProfile(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/mypage_profile?check_required=1', params);
            return new UserProfile(res.data, this.config);
        });
    }
    /**
     * 日毎のアクティビティのサマリを取得.
     * @param year
     * @param month
     * @param date
     */
    fetchDailyActivity(year, month, date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/summary/daily-activity?year=${year}&month=${month}&date=${date}`);
            return new Activity(res.data);
        });
    }
    fetchCurrentStreak() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/current_streak_with_freeze');
            return new CurrentStreak(res.data.response);
        });
    }
    fetchStreakCompletionSummary(year, month) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/streak_completion_summary_with_freeze?year=${year}&month=${month}`);
            return new StreakCompletionSummary(res.data.response);
        });
    }
    /**
     * 週のアクティビティのサマリを取得.
     */
    fetchWeeklyActivity(startDate, page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/summary/weekly-activity?start_date=${getFormattedToFormat(startDate)}&page=${page}`);
            return new Activity(res.data);
        });
    }
    /**
     * 月毎のアクティビティのサマリを取得.
     * @param year
     * @param month
     */
    fetchMonthlyActivity(startDate, page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/summary/monthly-activity?start_date=${getFormattedToFormat(startDate)}&page=${page}`);
            return new Activity(res.data);
        });
    }
    /**
     * 3ヶ月毎のアクティビティのサマリを取得.
     * @param page
     */
    fetchThreeMonthActivity(startDate, page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/summary/quarterly-activity?start_date=${getFormattedToFormat(startDate)}&page=${page}`);
            return new Activity(res.data);
        });
    }
    /**
     * アクティビティページで使う、レッスンを実施した日一覧を取得
     * @param year
     * @param month
     */
    fetchActivityCalendar(year, month) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/activity_calendar?year=${year}&month=${month}`);
            return res.data;
        });
    }
    /**
     * 視聴回数を取得
     */
    fetchLessonViewCounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/lesson_view_counts');
            return res.data || [];
        });
    }
    /**
     * プログラムfav一覧取得
     */
    fetchFavoritePrograms() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/favorite_programs');
            const favoriteProgramData = res.data || [];
            return favoriteProgramData.map((v) => {
                if (v.program.isPlaylist) {
                    return new Playlist(v.program, this.config);
                }
                return new Program(v.program, this.config);
            });
        });
    }
    /**
     * レッスンのfav(ページングしている)一覧取得
     * @param page
     */
    fetchFavoriteLessons(page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/favorite_lessons?page=${page}`);
            const favoriteLessonData = res.data || [];
            return favoriteLessonData.map((v) => new Lesson(v.lesson, this.config));
        });
    }
    /**
     * プログラムをfavする
     * @param params
     */
    addFavoriteProgram(programId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/favorite/program', { programId });
        });
    }
    /**
     * lessonをfavする
     * @param params
     */
    addFavoriteLesson(lessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/favorite/lesson', { lessonId });
        });
    }
    /**
     * programのfav解除
     * @param programId
     */
    unFavoriteProgram(programId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete(`/me/favorite/program/${programId}`);
        });
    }
    /**
     * lessonのfav解除
     * @param lessonId
     */
    unFavoriteLesson(lessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete(`/me/favorite/lesson/${lessonId}`);
        });
    }
    /**
     * programをfav済みかどうか
     */
    isFavoritedProgram(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/programs/${id}/is_favorited`);
            return res.data;
        });
    }
    /**
     * programのレッスンのお気に入り状態一覧を取得
     */
    fetchLessonsFavoriteStatus(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/programs/${id}/lessons/favorite_status`);
            return res.data || [];
        });
    }
    changePlan(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/subscription_plan_queue', params);
            return res.data;
        });
    }
    changePlanForUnsubscribeCp(basePlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = basePlanId ? { params: { base_plan_id: basePlanId } } : undefined;
            const res = yield this.axios.patch('/me/unsubscribe_cp_plan_queue_by_setting', undefined, params);
            return res.data;
        });
    }
    removeQueuedPlan() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.delete('/me/subscription_plan_queue');
            return res.data;
        });
    }
    getIsQueuedPlanForPricingRevision() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/check_queued_plan_for_pricing_revision');
            return res.data.response;
        });
    }
    /**
     * メルマガ購読解除
     * @param params
     */
    sendMagazineUnsubscribeToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/unsubscribe_magazine', params);
        });
    }
    /**
     * 動画視聴設定を変更する.
     * @param isAutoPlayNextVideo
     */
    UpdateViewingSetting(isAutoPlayNextVideo) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/viewing_setting', { isAutoPlayNextVideo });
            return res.data;
        });
    }
    // リーグ機能の参加可否（on/off）を更新する.
    updateLeagueParticipating(isLeagueParticipating) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/league/participating', { isLeagueParticipating });
            return new UserProfile(res.data.response, this.config);
        });
    }
    // 連続記録の達成画面の非表示設定（on/off）を更新する.
    updateStreakCompletionHidden(isStreakCompletionHidden) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/streak/completion_hidden', {
                isStreakCompletionHidden,
            });
            return new UserProfile(res.data.response, this.config);
        });
    }
    // 体重表示の表示・非表示（on/off）を更新する.
    UpdateWeightDisplay(isWeightHidden) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch('/me/weight_display', { isWeightHidden });
            return new UserProfile(res.data.response, this.config);
        });
    }
    /**
     * プロフィール画像をアップロードする.
     * @param params
     */
    uploadProfilePicture(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('profile_picture', params);
            const res = yield this.axios.patch('/me/profile_picture', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return res.data;
        });
    }
    /**
     * トレーナー一覧取得
     */
    fetchTrainers() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/trainers');
            const trainerData = res.data || [];
            return trainerData.map((v) => new Trainer(v, this.config));
        });
    }
    /**
     * トレーナー単体取得
     * @param trainerId
     */
    fetchTrainer(trainerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/trainers/${trainerId}`);
            return new Trainer(res.data, this.config);
        });
    }
    /**
     * インストラクターに紐づくプログラム一覧を取得
     */
    fetchProgramByInstructorID(instructorID, page, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/instructors/${instructorID}/programs?page=${page}&limit=${limit}`);
            const porgramData = res.data.response || [];
            return porgramData.map((v) => new Program(v, this.config));
        });
    }
    /**
     * インストラクターに紐づくレッスン一覧を取得
     */
    fetchLessonByInstructorID(instructorID, filter, page, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/instructors/${instructorID}/lessons?filter=${filter}&page=${page}&limit=${limit}`);
            const lessonData = res.data.response || [];
            return lessonData.map((v) => new Lesson(v, this.config));
        });
    }
    /**
     * インストラクターに紐づくLiveLesson一覧を取得
     */
    fetchLiveLessonByInstructorID(instructorID, page, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/instructors/${instructorID}/live_lessons?page=${page}&limit=${limit}`);
            const liveLessonData = res.data.response || [];
            return liveLessonData.map((v) => new LiveLesson(v, this.config));
        });
    }
    /**
     * インストラクターさんのレッスンが含まれているプレイリスト一覧を取得
     */
    fetchPlaylistByInstructorID(instructorID, page, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/playlists?instructor_id=${instructorID}&page=${page}&limit=${limit}`);
            const playlistData = res.data.response || [];
            return playlistData.map((v) => new Playlist(v, this.config));
        });
    }
    /**
     * メール認証
     * @param params
     */
    verifyEmail(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch(`/email_verifications`, params);
            return;
        });
    }
    /**
     * 目標設定診断一覧取得
     */
    fetchGoalMatchingAssessments(version) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/goal_matching_assessments?version=${version}`);
            const matchingAssessmentData = res.data.response || [];
            return matchingAssessmentData.map((v) => new MatchingAssessment(v, this.config));
        });
    }
    /**
     * 目標設定診断結果取得
     */
    fetchGoalMatchingAssessmentResult(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/goal_matching_assessments', params);
            return new GoalMatchingAssessmentResponse(res.data.response, this.config);
        });
    }
    /**
     * 目標設定診断結果取得（認証不要）
     */
    fetchGoalMatchingAssessmentResultUnauthenticated(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/goal_matching_assessment_result', params);
            return new GoalMatchingAssessmentResponse(res.data.response, this.config);
        });
    }
    /**
     * 目標設定診断ユーザ回答取得
     */
    fetchGoalMatchingAssessmentAnswer(version) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/goal_matching_assessment_answers?version=${version}`);
            const answerData = res.data.response || [];
            return answerData.map((v) => new GoalMatchingAssessmentAnswerResponse(v));
        });
    }
    /**
     * 目標設定診断で必須項目が回答されているかチェック
     */
    fetchGoalMatchingAssessmentAnswerCheck(version) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/goal_matching_assessment_answers_check?version=${version}`);
            return res.data.response;
        });
    }
    /**
     * 診断プロフィール登録
     */
    createDiagnosisProfile(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/diagnosis_profile', params);
        });
    }
    /**
     * 目標体重をチェック
     */
    checkWeightGoal(height, weight, weightGoal) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/goal_matching_assessments/weight_goal_validation?height=${height}&weight=${weight}&weight_goal=${weightGoal}`);
            return res.data.response;
        });
    }
    /**
     * 減量ペース詳細取得
     */
    fetchWeightGoalPace(weight, weightGoal, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/goal_matching_assessments/weight_goal_pace?weight=${weight}&weight_goal=${weightGoal}&version=${version}`);
            return res.data.response;
        });
    }
    /**
     * 減量ペース詳細取得
     */
    fetchWeightGoalApproach(activityLevel, gender, birthday, height, weight, weightGoal, paceChoiceId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParams = new URLSearchParams();
            urlParams.append('activity_level_id', activityLevel.toString());
            urlParams.append('gender_id', gender.toString());
            urlParams.append('birthday', birthday);
            urlParams.append('height', height.toString());
            urlParams.append('weight', weight.toString());
            urlParams.append('weight_goal', weightGoal.toString());
            urlParams.append('pace_choice_id', paceChoiceId.toString());
            urlParams.append('version', version.toString());
            const res = yield this.axios.get(`/goal_matching_assessments/weight_goal_approach?${urlParams.toString()}`);
            const weightGoalApproachResponseData = res.data.response || [];
            return weightGoalApproachResponseData.map((v) => new WeightGoalApproach(v));
        });
    }
    fetchBadges(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/badges', { params: { type } });
            const badgeData = res.data || [];
            return badgeData.map((v) => new Badge(v, this.config));
        });
    }
    /**
     * ユーザが獲得した未表示のバッジを取得
     */
    fetchUndisplayedBadges() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/undisplayed_badges');
            const badgeData = res.data || [];
            return badgeData.map((v) => new Badge(v, this.config));
        });
    }
    /**
     * ユーザーのバッジステータス更新
     */
    updateDisplayedUserBadges(badgeIds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/badges/displayed', { badgeIds });
        });
    }
    /**
     * プレイリスト一覧を取得
     */
    fetchPlaylists(page, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/playlists?page=${page}&sort_by=${sortBy}`);
            const playlistData = res.data || [];
            return playlistData.map((o) => new Playlist(o, this.config));
        });
    }
    /**
     * プレイリストを取得
     */
    fetchPlaylist(programId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/playlists/${programId}`);
            return new Playlist(res.data, this.config);
        });
    }
    /**
     * オリジナルプレイリストを取得
     */
    fetchOriginalPlaylist(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/original_playlists/${id}`);
            return new Playlist(res.data, this.config, true);
        });
    }
    /**
     * ユーザチャレンジの一覧取得(チャレンジステータスで検索)
     */
    fetchUserChallengesByChallengeStatus(challengeStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/challenges?challenge_status=${challengeStatus}`);
            const userChallengeData = res.data.response || [];
            return userChallengeData.map((v) => new UserChallenge(v, this.config));
        });
    }
    /**
     * チャレンジに参加する
     * @param params
     */
    startChallenge(programId, start, end) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { programId, start, end };
            const res = yield this.axios.post('/me/challenges', params);
            return new UserChallenge(res.data, this.config);
        });
    }
    /**
     * チャレンジ参加ステータスを更新する (ステータス：'in_progress','complete','stopped')
     * @param params
     */
    updateChallengeStatus(userChallengeId, programId, status, start, end) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { challengeStatus: status, programId, start, end };
            const res = yield this.axios.patch(`/me/challenges/${userChallengeId}`, params);
            return new UserChallenge(res.data, this.config);
        });
    }
    /**
     * レッスン視聴数ランキング取得
     * @param start
     * @param end
     * @param limit
     */
    fetchWatchedLessonRanking(start, end, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/ranking/lessons?start=${start}&end=${end}&limit=${limit}`);
            return res.data.map((v) => new WatchedLessonRanking(v, this.config));
        });
    }
    fetchDailyLessonRanking(limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const now = dayjs().startOf('day');
            const start = now.subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
            const end = now.subtract(1, 'second').format('YYYY-MM-DD HH:mm:ss');
            return yield this.fetchWatchedLessonRanking(start, end, limit);
        });
    }
    /**
     * ダイアログを取得
     */
    fetchDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/dialog');
            const dialogData = res.data.response;
            if (!dialogData)
                return null;
            return new Dialog(dialogData, this.config);
        });
    }
    /**
     * フッター情報を取得
     */
    fetchFooter() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/navigation_tabs');
            return new Footer(res.data.response, this.localStorage);
        });
    }
    /**
     * 性別リストを取得.
     */
    fetchGenders() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/genders');
            return res.data;
        });
    }
    /**
     * 都道府県リストを取得.
     */
    fetchPrefectures() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/prefectures');
            return res.data.map((v) => {
                return { name: v.name, value: v.value };
            });
        });
    }
    /**
     * 普段の運動量リストを取得.
     */
    fetchActivityLevels() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/activity_level');
            return res.data;
        });
    }
    /**
     * 悩みリストを取得.
     */
    fetchWorries() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/worries');
            return res.data.map((v) => {
                return { name: v.content, value: `${v.id}` };
            });
        });
    }
    /**
     * 興味リストを取得.
     */
    fetchInterests() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/interests');
            return res.data.map((v) => {
                return { name: v.content, value: `${v.id}` };
            });
        });
    }
    fetchMyDailyLesson() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`me/daily_lesson`);
            if (!res.data.response) {
                return null;
            }
            return new DailyLesson(res.data.response, this.config);
        });
    }
    fetchBeginnerMissions() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/beginner_missions');
            return new BeginnerMission(res.data.response, this.config);
        });
    }
    fetchMissionSummary() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/missions/summary');
            return new MissionSummary(res.data.response, this.config);
        });
    }
    fetchMissions() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/missions');
            return new MissionList(res.data.response, this.config);
        });
    }
    updateMissionsViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/missions/viewed');
        });
    }
    fetchCurrentDailyStartVolume() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`me/daily_start/current_volume`);
            if (!res.data.response) {
                return null;
            }
            return new DailyStartVolume(res.data.response, this.config);
        });
    }
    fetchDailyStart() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`me/daily_start`);
            if (!res.data.response) {
                return null;
            }
            return new DailyStart(res.data.response, this.config);
        });
    }
    fetchDailyLessonVolume(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`me/daily_lesson/volume/${id}`);
            return new DailyLessonVolume(res.data.response, this.config);
        });
    }
    fetchCourseDayBy(courseDaysLessonID) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/course_day/${courseDaysLessonID}`);
            if (!res.data.response) {
                return null;
            }
            return new CourseDay(res.data.response, this.config);
        });
    }
    fetchCustomWorkouts(keyword) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParams = keyword === '' ? '' : `?q=${keyword}`;
            const res = yield this.axios.get(`/custom_workouts/search${urlParams}`);
            if (!res.data.response) {
                return null;
            }
            return res.data.response.map((v) => {
                return new CustomWorkout(v);
            });
        });
    }
    fetchCalorie(customWorkoutID, duration) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/custom_workouts/calorie?custom_workout_id=${customWorkoutID}&duration=${duration}`);
            return res.data.response;
        });
    }
    postCustomWorkout(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/custom_workouts', params);
            return new UserCustomWorkout(res.data.response, this.config);
        });
    }
    updateCustomWorkout(id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.patch(`/me/custom_workouts/${id}`, params);
            return new UserCustomWorkout(res.data.response, this.config);
        });
    }
    deleteCustomWorkout(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete(`/me/custom_workouts/${id}`);
        });
    }
    /*------ Accountクローズ系 ------*/
    /**
     * 退会予約
     */
    scheduleUnsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/unsubscribe');
        });
    }
    /**
     * 退会予約取り消し
     */
    cancelUnsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete('/me/unsubscribe');
        });
    }
    /**
     * Androidアカウント削除
     */
    destroyAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete('/me/destroy_user_relation');
        });
    }
    /**
     * 休眠会員
     * @param params
     */
    dormantAccount(month) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/me/dormant', { months: month });
        });
    }
    /**
     * 休眠会員から復活
     */
    reactivateAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete('/me/dormant');
        });
    }
    /**
     * パスワードリセットのリクエスト(パスワードを変更したい、ということ)
     * @param params
     */
    requestResetPassword(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/password_resets', params);
        });
    }
    /** パスワード再設定リンクを消費せずに有効性を確認する。 */
    validatePasswordResetToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/password_resets/validate', { token });
            return res.data.response;
        });
    }
    /**
     * パスワードをリセットする。(本変更)
     * @param params
     */
    resetPassword(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch('/password_resets', params);
        });
    }
    /*------ Plan系 ------*/
    /**
     * Plan取得
     * @param stripePlanID
     */
    fetchPlanByStripePlanID(stripePlanID) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/plans/${stripePlanID}`);
            return new Plan(res.data, this.config);
        });
    }
    /**
     * 認証コードに紐づく登録用プラン取得
     */
    fetchPlanForNoPaymentSignup(collaborationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/plan/${collaborationCode}`);
            return new BasePlan({ plans: [res.data.response], amazonPayPlans: [] }, this.config);
        });
    }
    /**
     * 登録用Plan取得
     */
    fetchRegistablePlans(useOldPlan) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/base_plans?payment_channels=stripe,amazon_pay&use_old_plan=${+useOldPlan}`);
            return res.data.response.map((v) => new BasePlan(v, this.config));
        });
    }
    /**
     * 更新用Plan取得
     */
    fetchChangeablePlans() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('me/plans/changeable');
            const planData = res.data || [];
            return planData.map((v) => new Plan(v, this.config));
        });
    }
    /**
     * 退会時の割引CPのPlan取得
     */
    fetchChangeableUnsubscribeCpPlan(basePlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = basePlanId ? { params: { base_plan_id: basePlanId } } : undefined;
            const res = yield this.axios.get('me/plans/changeable_unsubscribe_cp_plan', params);
            const planData = res.data.response;
            return new Plan(planData, this.config);
        });
    }
    /**
     * キャンペーンコードをもとにPlan取得
     */
    fetchCampaignWithPlans(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/campaign_base_plans/${resolveSignupCampaignCode(code)}`);
            return new Campaign(res.data.response, this.config);
        });
    }
    /**
     * キャンペーンコードをもとにPlan取得
     */
    fetchAmazonPayPlanForSignUp() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/amazon_pay_plan_for_signup');
            return new AmazonPayPlan(res.data.response);
        });
    }
    /**
     * 参加予定のライブレッスンを取得
     */
    fetchSubscribedLiveLesson() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/live_lessons/subscribe`);
            return res.data.response.map((live) => new LiveLesson(live, this.config));
        });
    }
    /**
     * ライブレッスンに参加する予定かどうかを取得
     */
    fetchLiveLessonAttendanceStatus(liveLessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/live_lessons/${liveLessonId}/is_subscribed`);
            return res.data;
        });
    }
    /**
     * ライブレッスンに参加する予定にする
     */
    attendLiveLesson(liveLessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post(`/me/live_lessons/${liveLessonId}/subscribe`);
            return res.data;
        });
    }
    /**
     * ライブレッスンに参加しない予定にする
     */
    absentLiveLesson(liveLessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.delete(`/me/live_lessons/${liveLessonId}/unsubscribe`);
            return res.data;
        });
    }
    /**
     * 開催日時で絞ってライブレッスンを取得
     */
    fetchLiveLessonsByStartsAt(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/live_lessons?start_at_from=${from}&start_at_to=${to}`);
            return res.data.response.map((live) => new LiveLesson(live, this.config));
        });
    }
    /**
     * 見逃し配信中のライブレッスンを取得
     */
    fetchRebroadcastLiveLessons() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/live_lessons/rebroadcast');
            return res.data.response.map((live) => new LiveLesson(live, this.config));
        });
    }
    /**
     * 単一ライブレッスンを取得
     */
    fetchLiveLesson(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axios
                .get(`me/live_lessons/${id}`)
                .then((v) => {
                if (!v)
                    return null;
                return new LiveLesson(v.data.response, this.config);
            })
                .catch((e) => {
                if (e.isNotFoundError)
                    return null;
                throw e;
            });
        });
    }
    /**
     * 次のライブレッスンを取得
     */
    fetchNextLiveLesson() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/live_lessons/next`);
            if (!res.data)
                return null;
            return new LiveLesson(res.data, this.config);
        });
    }
    /**
     * 動画の検索
     */
    search(searchParams_1) {
        return __awaiter(this, arguments, void 0, function* (searchParams, page = 0) {
            const urlParams = new URLSearchParams();
            urlParams.append('page', page.toString());
            if (searchParams) {
                if (searchParams.sortBy)
                    urlParams.append('sort_by', searchParams.sortBy);
                if (searchParams.category)
                    urlParams.append('category', searchParams.category);
                if (searchParams.q)
                    urlParams.append('q', searchParams.q);
                if (searchParams.styleId)
                    urlParams.append('style_id', searchParams.styleId);
                if (searchParams.difficultyId)
                    urlParams.append('difficulty_id', searchParams.difficultyId);
                if (searchParams.durationId)
                    urlParams.append('duration_id', searchParams.durationId);
            }
            const res = yield this.axios.get(`/search_contents?${urlParams.toString()}`);
            return new SearchResult(res.data.response, this.config);
        });
    }
    /**
     * Facebook Conversion APIにデータを送信
     * @param params
     */
    postConversionToFB(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/conversion', params);
        });
    }
    /**
     * お知らせ一覧取得
     */
    fetchAnnouncements(page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/announcements?page=${page}`);
            return new Announcements(res.data, this.config);
        });
    }
    /**
     * 対象のお知らせ取得
     */
    getAnnouncement(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axios
                .get(`/me/announcements/${id}`)
                .then((v) => {
                if (!v)
                    return null;
                return new Announcement(v.data, this.config);
            })
                .catch((e) => {
                if (e.isNotFoundError)
                    return null;
                throw e;
            });
        });
    }
    /**
     * 対象のお知らせを既読にする
     */
    updateAnnouncementReadInformation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post(`/me/announcements/${id}`);
        });
    }
    /**
     * 全ての未読お知らせを既読にする
     */
    updateAllAnnouncementReadInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.patch(`/me/announcements`);
        });
    }
    /**
     * お知らせ未読情報取得
     */
    getUnreadAnnouncementCount() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/unread_announcement');
            return res.data;
        });
    }
    /**
     * オリジナルプレイリスト作成
     */
    createOriginalPlaylist(name, lessonIds, file, description) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('name', name);
            lessonIds.forEach((id, i) => {
                data.append(`lesson_ids[${i}]`, id.toString());
            });
            data.append('thumbnail_file', file);
            data.append('description', description);
            const res = yield this.axios.post('/me/original_playlists', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return res.data.id;
        });
    }
    /**
     * オリジナルプレイリスト更新
     */
    updateOriginalPlaylist(name, lessonIds, file, description, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('name', name);
            lessonIds.forEach((id, i) => {
                data.append(`lesson_ids[${i}]`, id.toString());
            });
            if (file)
                data.append('thumbnail_file', file);
            data.append('description', description);
            const res = yield this.axios.patch(`/me/original_playlists/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return res.data;
        });
    }
    /**
     * オリジナルプレイリスト削除
     */
    deleteOriginalPlaylist(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.delete(`/me/original_playlists/${id}`);
            return res.data;
        });
    }
    /**
     * オリジナルプレイリスト一覧取得
     */
    getOriginalPlaylists() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/original_playlists');
            return res.data.map((o) => new Playlist(o, this.config, true));
        });
    }
    /**
     * 検索のキーワード一覧取得
     */
    getKeywords() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/keywords?type=hotkeyword');
            return res.data;
        });
    }
    /**
     * ホームに表示するバナー取得
     */
    getHomeBanners() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/home_banners`);
            return res.data.response.map((v) => new Banner(v, this.config));
        });
    }
    /**
     * ライブ配信ページに表示するバナー取得
     */
    getLiveLessonBanners() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/live_lesson_banners`);
            return res.data.response.map((v) => new Banner(v, this.config));
        });
    }
    /**
     * ランク一覧取得
     */
    getUserSeasonAggregates() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/user_season_aggregates');
            return res.data.response.map((v) => new UserSeasonAggregate(v, this.config));
        });
    }
    /**
     * リーグの状態取得
     */
    fetchLeagueStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/league/status');
            return new LeagueStatus(res.data.response, this.config);
        });
    }
    /**
     * リーグのリーダーボード取得
     */
    fetchLeagueLeaderboard() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/league/leaderboard');
            return new LeagueLeaderboard(res.data.response, this.config);
        });
    }
    /**
     * カウントレッスン一覧取得
     */
    fetchCountLessons() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/count_lessons');
            return new CountLessons(res.data.response, this.config);
        });
    }
    /**
     * カウントレッスンのコーチ一覧取得
     */
    fetchCountLessonCoaches() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/count_lesson_coaches');
            return res.data.response.map((v) => new CountLessonCoach(v, this.config));
        });
    }
    /**
     * カウントレッスンのコーチ選択/変更
     */
    selectCountLessonCoach(countLessonCoachId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.put('/me/count_lesson_coach', { countLessonCoachId });
        });
    }
    /**
     * カウントレッスン詳細取得(プレイ画面用データ)
     */
    fetchCountLesson(countLessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/count_lessons/${countLessonId}`);
            return new CountLessonDetail(res.data.response, this.config);
        });
    }
    /**
     * カウントレッスンのセッション開始
     */
    startCountLessonSession(countLessonId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/count_lesson_sessions', {
                countLessonId,
            });
            return res.data.response.sessionId;
        });
    }
    /**
     * カウントレッスンのセッション完了(実施結果の記録とカロリー等の計算)
     * レスポンスの完了結果(ストリーク・リーグ)は完了画面のオーバーレイ表示に使う
     */
    finishCountLessonSession(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            // 完了直後にタブ閉鎖・リロード・WebView破棄されると通常のXHRは中断される。
            // ライブ完了と同様、keepalive付きfetchで送り切る(sendBeaconはPATCH不可)。
            const res = yield this.axios.patch('/me/count_lesson_sessions/finish', { sessionId }, {
                adapter: 'fetch',
                fetchOptions: { keepalive: true },
            });
            return new CountLessonCompletionResult(res.data.response, this.config);
        });
    }
    /**
     * TwitterのOauth認証が完了しているか確認
     */
    confirmTwitterAuthorization() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/tw/confirm_authorization');
            return res.data.response;
        });
    }
    /**
     * TwitterのOauth認証画面URL取得
     */
    twitterAuthorization() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/tw/authorization');
            return res.data.response;
        });
    }
    /**
     * Twitter投稿実行
     */
    postTweet(params, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('tweet_text', params.text);
            data.append('img_file', file);
            const res = yield this.axios.post('/me/tw/post', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return res.data.response;
        });
    }
    /**
     * 指定日の最新体重、体脂肪率の取得
     */
    fetchTargetWeightAndBodyFat(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/target_weight_and_body_fat?target_date=${getFormattedToFormat(date)}`);
            if (!res.data.response) {
                return null;
            }
            return new TargetWeightAndBodyFat(res.data.response);
        });
    }
    /**
     * 体重、体脂肪率ログのリクエスト
     */
    postUserWeightAndBodyFat(weight, bodyFat, date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/weight_and_body_fat', { weight, bodyFat, date: getFormattedToFormat(date) });
            return new SaveUserWeightResult(res.data.response, this.config);
        });
    }
    /**
     * 1日毎のレッスン時間合計
     */
    getLessonSessionByDaily(page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/lesson_session_by_daily?page=${page}`);
            return res.data.response.userLessonSessionGroupByDaily.map((v) => new UserLessonSessionGroupByDaily(v));
        });
    }
    /**
     * 体重、体脂肪率ログ一覧
     */
    getUserWeightsAndBodyFat(date, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/activity/weights_and_body_fat?date=${getFormattedToFormat(date)}&limit=${limit}`);
            return new WeightAndBodyFatActivities(res.data.response);
        });
    }
    /**
     * 友達紹介キャンペーン情報取得
     */
    getFriendInvitationCampaign() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/friend_invitation_campaign`);
            return new FriendInvitationCampaign(res.data.response, this.config);
        });
    }
    /**
     * AmazonPay決済でクレカ登録
     */
    registerAmazonPay(sessionId, planId, invitationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/register_amazon_pay', { sessionId, planId, invitationCode });
        });
    }
    /**
     * AmazonPay決済で新規登録
     */
    signupForAmazonPay(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/signup_from_amazon_pay', { sessionId });
            return res.data.response;
        });
    }
    /**
     * AmazonPay決済完了用のリダイレクトURLを取得
     */
    checkoutFromAmazonPay(sessionId, planId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/checkout_from_amazon_pay', { sessionId, planId });
            return res.data.response;
        });
    }
    /**
     * 商品一覧を取得
     */
    getMerchandises(page) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/merchandises_with_image_url?page=${page}`);
            return res.data.response.map((v) => new Merchandise(v));
        });
    }
    fetchWorkoutCalories(startDate, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/activity/workout_calories?start_date=${getFormattedToFormat(startDate)}&limit=${limit}`);
            return new WorkoutCalories(res.data.response);
        });
    }
    fetchStepActivities(startDate, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/activity/steps?start_date=${getFormattedToFormat(startDate)}&limit=${limit}`);
            return new StepActivities(res.data.response);
        });
    }
    fetchStepGoals() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/step_goals');
            return res.data.response;
        });
    }
    saveStepGoal(steps) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.put('/me/step_goal', { steps: steps });
        });
    }
    fetchWorkoutGoals() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/workout_goals');
            return res.data.response.map((v) => {
                return { name: v.targetCalories.toString(), value: v.id.toString() };
            });
        });
    }
    saveWorkoutGoal(workoutGoalId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.put('/me/workout_goal', { workoutGoalId });
        });
    }
    saveWeightGoal(weightGoal) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.put('/me/weight_goal', { weightGoal });
        });
    }
    fetchDailyWorkoutTask(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/daily_tasks/workout?date=${date}`);
            return new DailyWorkoutTask(res.data.response, this.config);
        });
    }
    fetchDailyStepsTask(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/daily_tasks/steps?date=${date}`);
            return new DailyStepsTask(res.data.response);
        });
    }
    fetchDailyTasks(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/daily_tasks?date=${getFormattedToFormat(date)}`);
            return new DailyTasks(res.data.response);
        });
    }
    fetchDailyTaskGoal(taskName, date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/daily_tasks/${taskName}/goal?date=${date}`);
            return res.data.response;
        });
    }
    fetchMealScores(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/meal_scores?date=${getFormattedToFormat(date)}`);
            return new MealScore(res.data.response);
        });
    }
    fetchMealNutrients(date, type) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const res = yield this.axios.get(`/me/meal_nutrient_balances?date=${getFormattedToFormat(date)}&type=${type}`);
            return {
                isEntered: res.data.response.isEntered,
                nutrients: ((_a = res.data.response.nutrients) === null || _a === void 0 ? void 0 : _a.map((v) => new Nutrient(v))) || [],
            };
        });
    }
    fetchMealMenus(keyword) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const res = yield this.axios.get(`/me/meal_menus?q=${keyword}`);
            const mealMenu = ((_a = res.data.response.menus) === null || _a === void 0 ? void 0 : _a.map((mealMenuData) => new MealMenu(mealMenuData))) || [];
            return { mealMenu: mealMenu, error: res.data.response.calomealErrMessage };
        });
    }
    fetchMealHistories(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/meal_item_histories?type=${type}`);
            return res.data.response.items.map((item) => new MealMenu(item));
        });
    }
    fetchMealPresets() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/me/meal_presets');
            return res.data.response.presets.map((preset) => new MealPreset(preset));
        });
    }
    analyzeMealItemsFromText(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/meal_items/analyze_text', { text }, { timeout: 60000 });
            return res.data.response.items.map((item) => new MealMenu(item));
        });
    }
    analyzeMealItemsFromPhoto(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('meal_image', file);
            const res = yield this.axios.post('/me/meal_items/analyze_photo', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 60000,
            });
            return {
                items: res.data.response.items.map((item) => new MealMenu(item)),
                analysisType: res.data.response.analysisType,
            };
        });
    }
    createMealPreset(name, items) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/meal_presets', {
                name,
                items: items.map((item) => item.toMealItemJSON()),
            });
            return new MealPreset(res.data.response);
        });
    }
    updateMealPreset(id, name, items) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.put(`/me/meal_presets/${id}`, {
                name,
                items: items.map((item) => item.toMealItemJSON()),
            });
            return new MealPreset(res.data.response);
        });
    }
    deleteMealPreset(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.delete(`/me/meal_presets/${id}`);
        });
    }
    fetchMealCalories(date, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/activity/meal_calories?start_date=${getFormattedToFormat(date)}&limit=${limit}`);
            const mealCalorie = res.data.response.mealCalorieList.map((v) => new MealCalorie(v)) || [];
            return {
                mealCalories: mealCalorie,
                graphScales: res.data.response.graphScales,
                averageCalorie: res.data.response.averageCalorie,
                lastTimeDiff: res.data.response.lastTimeDiff,
            };
        });
    }
    saveMealRecord(date_1, time_1, type_1, items_1) {
        return __awaiter(this, arguments, void 0, function* (date, time, type, items, imageIDs = [], images = [], imageAnalysisTypes = []) {
            const data = new FormData();
            data.append('date', getFormattedToFormat(date));
            data.append('time', time);
            data.append('type', type);
            data.append('items', JSON.stringify(items.map((item) => item.toMealItemJSON())));
            imageIDs.forEach((id) => data.append('image_ids', id.toString()));
            images.forEach((image, index) => data.append(`images[${index}]`, image));
            imageAnalysisTypes.forEach((analysisType) => data.append('image_analysis_types', analysisType));
            const res = yield this.axios.put('/me/meal_record', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 60000,
            });
            return res.data.response;
        });
    }
    skipMealRecord(date, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.put('/me/meal_record/skip', {
                date: getFormattedToFormat(date),
                type,
            });
            return res.data.response;
        });
    }
    saveMeal(date, time, type, keepImageIDs, menus, files) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('type', type);
            data.append('date', date);
            data.append('time', time);
            keepImageIDs.forEach((id, i) => {
                data.append(`image_ids[${i}]`, id.toString());
            });
            data.append('menus', JSON.stringify(menus.map((v) => v.toJSON())));
            files.forEach((file, i) => {
                data.append(`images[${i}]`, file);
            });
            const res = yield this.axios.put('/me/user_meal_with_images', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 60000,
            });
            return new UserMeal(res.data.response, this.config);
        });
    }
    getMeal(date, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/meal_record?date=${date}&type=${type}`);
            return res.data.response ? new UserMeal(res.data.response, this.config) : null;
        });
    }
    fetchMealsForDay(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/user_meals?date=${getFormattedToFormat(date)}`);
            return res.data.response ? new UserMealsForDay(res.data.response, this.config) : null;
        });
    }
    fetchMealRecordsForDay(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/meal_records?date=${getFormattedToFormat(date)}`);
            return res.data.response;
        });
    }
    saveMealRecordFromText(date, time, type, text) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/meal_record/text', {
                date: getFormattedToFormat(date),
                time,
                type,
                text,
            }, { timeout: 60000 });
            return res.data.response;
        });
    }
    saveMealRecordFromPhoto(date, time, type, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('date', getFormattedToFormat(date));
            data.append('time', time);
            data.append('type', type);
            data.append('meal_image', file);
            const res = yield this.axios.post('/me/meal_record/photo', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 60000,
            });
            return res.data.response;
        });
    }
    fetchMealNutrientBalancesForDay(date) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/me/meal_nutrient_balances?date=${getFormattedToFormat(date)}&type=all`);
            return res.data.response;
        });
    }
    fetchUnsubscribeChatbotSection(sectionID) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = sectionID ? `?id=${sectionID}` : '';
            const res = yield this.axios.get(`/me/unsubscribe_chatbot/section${queryParams}`);
            return new ChatbotSection(res.data.response);
        });
    }
    fetchLiveLessonProgramSection() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/live_lesson_program_section');
            const porgramData = res.data.response || [];
            return porgramData.map((v) => new Program(v, this.config));
        });
    }
    fetchDifficulties() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/difficulties');
            return res.data.response;
        });
    }
    getDormantFinishDay(month) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get(`/dormant_finish_day?month=${month}`);
            return res.data.response.dormantFinishDay;
        });
    }
    confirmTvSession(token) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/confirm_tv_session', { token });
        });
    }
    saveLinebotConversionLog() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/me/line_lp_cv_log');
        });
    }
    getUnsubscribeCautionLessons() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/unsubscribe_caution_lessons');
            const result = res.data.response || [];
            return result.map((v) => new UnsubscribeCautionLesson(v, this.config));
        });
    }
    fetchDailyLessonChangeReasons() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.get('/daily_lesson_change_reasons');
            return res.data.response;
        });
    }
    changeDailyLessonLesson(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.axios.post('/me/daily_lesson/lessons/change', params);
            if (!res.data.response) {
                return null;
            }
            return new DailyLessonDaysLesson(res.data.response, this.config);
        });
    }
}
__decorate([
    bind
], APIClient.prototype, "appendToSequence", null);
__decorate([
    bind
], APIClient.prototype, "startLiveLessonWatchingRecord", null);
__decorate([
    bind
], APIClient.prototype, "finishLiveLessonWatchingRecord", null);
__decorate([
    bind
], APIClient.prototype, "syncLiveLessonWatchingRecord", null);
__decorate([
    bind
], APIClient.prototype, "patchProfile", null);
__decorate([
    bind
], APIClient.prototype, "fetchDailyActivity", null);
__decorate([
    bind
], APIClient.prototype, "addFavoriteProgram", null);
__decorate([
    bind
], APIClient.prototype, "addFavoriteLesson", null);
__decorate([
    bind
], APIClient.prototype, "unFavoriteProgram", null);
__decorate([
    bind
], APIClient.prototype, "unFavoriteLesson", null);
__decorate([
    bind
], APIClient.prototype, "updateDisplayedUserBadges", null);
__decorate([
    bind
], APIClient.prototype, "fetchSubscribedLiveLesson", null);
__decorate([
    bind
], APIClient.prototype, "fetchLiveLessonAttendanceStatus", null);
__decorate([
    bind
], APIClient.prototype, "attendLiveLesson", null);
__decorate([
    bind
], APIClient.prototype, "absentLiveLesson", null);
__decorate([
    bind
], APIClient.prototype, "fetchLiveLesson", null);
__decorate([
    bind
], APIClient.prototype, "getLessonSessionByDaily", null);
__decorate([
    bind
], APIClient.prototype, "getUserWeightsAndBodyFat", null);
__decorate([
    bind
], APIClient.prototype, "getFriendInvitationCampaign", null);
